<template>
    <div class="title-section alert alert-secondary p-1 shadow-sm">
        <div class='trending-products p-2'>
            <h3 class="text-capitalize">Trending Products</h3>
            <p v-if="para" v-html="para"></p>
            <div class="d-flex flex-row">
                <h4>Next Update In:</h4>
                <h4 class="text-danger" style="padding-left: 8px;"  v-if="pending">{{ endDate }}</h4>
                <h4 class="text-danger" style="padding-left: 8px;" id="dynamic-counter" v-else></h4>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrendingProductUpdateTrendNotice",
    props: {
      endDate: { required: true },
      para: { default: '' },
      pending: { default: false },
    },
    data(){
        return {
            x:null
        }
    },
    unmounted() {
        if(this.x)
        {
            clearInterval(this.x);
            document.getElementById('dynamic-counter').innerHTML = '-';
        }
    },
    mounted()
    {
        if(! this.pending)
        {
            document.getElementById('dynamic-counter').innerHTML = '-'
            var countDownDate = new Date(this.endDate).getTime();
            // Update the count down every 1 second
            this.x = setInterval(function () {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                var days = Math.floor( distance/(1000*60*60*24)) * 24;
                hours = days + hours;

                if(hours < 10) {
                    hours = '0' + hours;
                }
                if(minutes < 10) {
                    minutes = '0' + minutes;
                }

                if(seconds < 10) {
                    seconds = '0' + seconds;
                }

                // Output the result in an element with id="demo"
                document.getElementById('dynamic-counter').innerHTML =
                    hours + ':' + minutes + ':' + seconds ;

                // If the count down is over, write some text
                if (distance < 0) {
                    if(this.x)
                    {
                        clearInterval(this.x);
                    }
                    document.getElementById('dynamic-counter').innerHTML = '-';
                }
            }, 1000);
        }
    }
}
</script>
